import { forwardRef } from 'react'

import {
  CardContainer,
  FireCardContentContainer,
  FireCardImageContainer,
} from './FireCard.styles'
import { FireCardProps } from './FireCard.types'

export const FireCard = forwardRef<HTMLDivElement, FireCardProps>(
  ({ Image, settings, children, ...props }, ref) => {
    const desktopImagePosition = settings?.imagePosition?.desktop ?? 'top'
    const mobileImagePosition = settings?.imagePosition?.mobile ?? 'top'
    const imagePadding = settings?.imagePadding ?? true
    const background = settings?.background ?? true
    const hasImage = Boolean(Image)

    return (
      <CardContainer
        $desktopImagePosition={desktopImagePosition}
        $mobileImagePosition={mobileImagePosition}
        $background={background}
        $hasImage={hasImage}
        ref={ref}
        {...props}
      >
        {Image && (
          <FireCardImageContainer
            $padding={imagePadding}
            $desktopImagePosition={desktopImagePosition}
            $mobileImagePosition={mobileImagePosition}
          >
            {Image}
          </FireCardImageContainer>
        )}
        <FireCardContentContainer
          $desktopImagePosition={desktopImagePosition}
          $mobileImagePosition={mobileImagePosition}
          $hasImage={hasImage}
        >
          {children}
        </FireCardContentContainer>
      </CardContainer>
    )
  }
)
